import { render } from "./DuvidasView.vue?vue&type=template&id=38c92f26"
import script from "./DuvidasView.vue?vue&type=script&lang=js"
export * from "./DuvidasView.vue?vue&type=script&lang=js"

import "./DuvidasView.vue?vue&type=style&index=0&id=38c92f26&lang=scss"

import exportComponent from "/home/runner/work/topnetms/topnetms/apps/topnetms_site_v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__